(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-html-section"] && !Shopify.designMode) return;
  try {
    
$(".text-wrapper").each(function() {
         var html = $(this).html().split(" ");
         html = html.slice(0,50).join(" ") + '<span class="dots">...</span><div class="full-text">' + html.slice(50).join(" ");
         $(this).html(html);
    });

    $('.full-text').hide();

    $('.readmore-btn').click(function (event) {
        event.preventDefault();
        var dots_visibility = $(this).siblings(".text-wrapper").find("span.dots");
        dots_visibility.html(dots_visibility.html() == '...' ? ' ' : '...')
        $('.text-wrapper > p.p1').contents().unwrap();
        $(this).parent().find('.full-text').slideToggle('200');
        $(this).html($(this).html() == 'Read less' ? 'Read more' : 'Read less');
    });
  } catch(e) { console.error(e); }
})();
})();
